import { useMemo } from 'react';

const useListElements = (classSelector: string, deps: unknown[]) => {
  const linkElements = useMemo(() => {
    return typeof document !== 'undefined' && Array.from(document?.querySelectorAll(classSelector));
  }, deps);

  return linkElements;
};

export default useListElements;
